/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   imgix constructUrlFromParams
 *                https://github.com/imgix/react-imgix/blob/master/src/constructUrl.js
 */

import { createPath, parsePath } from 'history'
import Qs from 'querystringify'
import { oforEach } from '../../utils/oforEach'

import { IMGIX_OPTIONS } from './constants'

const constructUrlFromParams = (src, params) => {
  if (!src) {
    return ''
  } else if (!params) {
    return src
  }

  const { hash, pathname, search } = parsePath(src)
  const paramsDict = search ? Qs.parse(search) : {}

  oforEach(params, (val, key) => {
    if (val && IMGIX_OPTIONS.has(key)) {
      paramsDict[key] = val
    }
  })

  const constructedSearch = Qs.stringify(paramsDict, true)
  const constructedPath = pathname.replace(/\/$/, '')

  return createPath({
    hash,
    pathname: constructedPath,
    search: constructedSearch,
  })
}

export default constructUrlFromParams
